import React from 'react';
import ContentLoader from 'react-content-loader'

const SliderLoader = () => {
    return (
        <ContentLoader viewBox="0 0 1140 370">
            <rect x="0" y="20" rx="5" ry="5" width="570" height="370" />
            <rect x="620" y="70" rx="4" ry="4" width="127" height="17" />
            <rect x="620" y="95" rx="4" ry="4" width="450" height="27" />
            <rect x="620" y="130" rx="4" ry="4" width="200" height="27" />
            <rect x="620" y="175" rx="4" ry="4" width="450" height="14" />
            <rect x="620" y="200" rx="4" ry="4" width="420" height="14" />
            <rect x="620" y="225" rx="4" ry="4" width="432" height="14" />
            <rect x="620" y="250" rx="4" ry="4" width="422" height="14" />
            <rect x="620" y="276" rx="4" ry="4" width="445" height="14" />
            <rect x="620" y="310" rx="4" ry="4" width="132" height="10" />
            <rect x="620" y="330" rx="4" ry="4" width="170" height="10" />
        </ContentLoader>
    );
};



export default SliderLoader;